import { defineStore } from 'pinia';
import { ref } from 'vue';
import { Breadcrumb } from '@shared/types/Breadcrumb';

export const useBreadCrumbsStore = defineStore('breadcrumbs', () => {
  const breadcrumbsLabel = ref('');
  const breadcrumbsPaths = ref<Breadcrumb[]>([]);

  return { breadcrumbsPaths, breadcrumbsLabel };
});
